__turbopack_context__.v({
  "className": "open_sans_83e96604-module__IolVoq__className",
});
